<style scoped>
.round {
    border-radius: 50%;
}

.sidebar {
    padding-bottom: 50px;
}

.sidebar-menu .treeview-menu > li > a {
    padding: 12px 5px 11px 15px;
}

span.svg-icon {
    width: 30px;
    display: inline-block;
    line-height: 1;
    position: relative;
    top: 5px;
}
</style>
<style>
.svg-icon svg {
    height: 20px;
}

@keyframes jump {
    0% {
        transform: translate3d(0, 0, 0) scale3d(1, 1, 1);
    }

    40% {
        transform: translate3d(0, 30%, 0) scale3d(0.7, 1.5, 1);
    }

    100% {
        transform: translate3d(0, 100%, 0) scale3d(1.5, 0.7, 1);
    }
}

.jump {
    transform-origin: 50% 50%;
    animation: jump 0.5s linear alternate infinite;
}

.products-name {
    max-width: 145px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: text-top;
    line-height: 1.37;
}

.sidebar .sidebar-menu li > a > .pull-right-container {
    margin-top: -4px;
    right: 8px;
}

/* For demo: */
/*body {
  text-align: center;
}*/
/*body * {
  margin: 2em 2em 0;
  text-align: center;
  vertical-align: middle;
  font-family: sans-serif, sans;
  font-weight: bold;
}*/
.user-panel {
    min-height: 150px;
}
</style>
<template>
    <aside class="main-sidebar">
        <section class="sidebar">
            <div class="user-panel">
                <div class="image">
                    <img v-if="!is90d" src="/static/img/avatar2.png" class="img-circle" alt="User Image" />
                </div>
                <div class="info">
                    <p></p>

                    <div>
                        <!-- <a href="/admin/password/change"><i class="ti-user"></i><small>Profile</small></a> -->
                        <a @click="logout()"><i class="ti-power-off"></i><small>Logout</small></a>
                    </div>
                </div>
                <img class="bg-user" src="/static/img/avatar-bg.png" alt="User Image" />
            </div>

            <ul class="sidebar-menu">
                <li class="treeview">
                    <router-link to="/admin/publishers/">
                        <span class="svg-icon">
                            <i class="fa fa-users" style="font-size: 17px" aria-hidden="true"></i>
                        </span>
                        <span>Publishers</span>
                        <span class="pull-right-container"></span>
                    </router-link>
                </li>
                <li class="treeview">
                    <router-link to="/admin/domains/">
                        <span class="svg-icon">
                            <svg
                                aria-hidden="true"
                                width="20px"
                                height="20px"
                                data-prefix="fal"
                                data-icon="globe"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 496 512"
                                class="svg-inline--fa fa-globe fa-w-16"
                            >
                                <path
                                    fill="currentColor"
                                    d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm193.2 152h-82.5c-9-44.4-24.1-82.2-43.2-109.1 55 18.2 100.2 57.9 125.7 109.1zM336 256c0 22.9-1.6 44.2-4.3 64H164.3c-2.7-19.8-4.3-41.1-4.3-64s1.6-44.2 4.3-64h167.4c2.7 19.8 4.3 41.1 4.3 64zM248 40c26.9 0 61.4 44.1 78.1 120H169.9C186.6 84.1 221.1 40 248 40zm-67.5 10.9c-19 26.8-34.2 64.6-43.2 109.1H54.8c25.5-51.2 70.7-90.9 125.7-109.1zM32 256c0-22.3 3.4-43.8 9.7-64h90.5c-2.6 20.5-4.2 41.8-4.2 64s1.5 43.5 4.2 64H41.7c-6.3-20.2-9.7-41.7-9.7-64zm22.8 96h82.5c9 44.4 24.1 82.2 43.2 109.1-55-18.2-100.2-57.9-125.7-109.1zM248 472c-26.9 0-61.4-44.1-78.1-120h156.2c-16.7 75.9-51.2 120-78.1 120zm67.5-10.9c19-26.8 34.2-64.6 43.2-109.1h82.5c-25.5 51.2-70.7 90.9-125.7 109.1zM363.8 320c2.6-20.5 4.2-41.8 4.2-64s-1.5-43.5-4.2-64h90.5c6.3 20.2 9.7 41.7 9.7 64s-3.4 43.8-9.7 64h-90.5z"
                                    class=""
                                ></path>
                            </svg>
                        </span>
                        <span>Domains</span>
                        <span class="pull-right-container"></span>
                    </router-link>
                </li>
                <li class="treeview" v-for="nav in navigation" :key="nav.name">
                    <router-link
                        :to="`${nav.path}`"
                        v-if="
                            (nav.path && nav.path.indexOf('dfp-settings') == -1) ||
                            (nav.path && nav.path.indexOf('dfp-settings') > -1 && hasAccess)
                        "
                    >
                        <i :class="`${nav.icon}`" v-if="!nav.isSvg"></i>
                        <span class="svg-icon" v-if="nav.isSvg" v-html="nav.icon"></span>
                        <span>{{ nav.name }}</span>
                        <span class="pull-right-container" v-if="nav.modules.length"
                            ><i class="fa fa-angle-left pull-right"></i
                        ></span>
                    </router-link>
                    <a href="javascript:void(0);" v-if="!nav.path">
                        <i :class="`${nav.icon}`" v-if="!nav.isSvg"></i>
                        <span class="svg-icon" v-if="nav.isSvg" v-html="nav.icon"></span>
                        <span class="products-name">{{ nav.name }}</span>
                        <span class="pull-right-container" v-if="nav.modules.length"
                            ><i class="fa fa-angle-left pull-right"></i
                        ></span>
                    </a>
                    <ul class="treeview-menu sidebar-menu" style="display: block" v-if="nav.modules.length">
                        <li
                            class="treeview"
                            :class="module.link === currentPath ? 'active' : ''"
                            v-for="(module, index) in nav.modules"
                            :key="index"
                            v-if="isNavigationAllowed(module)"
                        >
                            <router-link :to="`${module.link}`">
                                <div class="vue-avatar--wrapper">
                                    <span><img class="round" width="20" height="20" :avatar="`${module.name}`" /></span>
                                </div>
                                {{ module.name }}
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li class="treeview">
                    <router-link to="/admin/bidders/">
                        <span class="svg-icon">
                            <i class="fa fa-users" style="font-size: 17px" aria-hidden="true"></i>
                        </span>
                        <span>Bidders</span>
                        <span class="pull-right-container"></span>
                    </router-link>
                </li>
            </ul>
        </section>
    </aside>
</template>
<script>
import Vue from 'vue';
import Avatar from 'vue-avatar';
import axios from 'axios';
import LetterAvatar from '../../../static/plugins/letterAvatar.js';

let sidebarObj = {
    Domain: [
        {
            icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-sliders-h fa-w-18" width="20px" height="20px"><path fill="currentColor" d="M576 80v40c0 6.6-5.4 12-12 12H160v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-8H12c-6.6 0-12-5.4-12-12V80c0-6.6 5.4-12 12-12h84v-8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v8h404c6.6 0 12 5.4 12 12zm-12 148h-84v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h404v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0 160H288v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h212v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h276c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/dfp-settings/',
            name: 'DFP Settings',
            modules: [],
        },
        {
            icon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="file-alt" class="svg-inline--fa fa-file-alt fa-w-12" role="img" viewBox="0 0 384 512"><path fill="currentColor" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"/></svg>',
            isSvg: true,
            path: '/admin/reports/',
            name: 'Reports',
            modules: [],
        },
    ],

    EditDomain: [
        {
            icon: '<svg aria-hidden="true" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16"  width="20px" height="20px"><path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/edit/{domId}/',
            name: 'Buckets',
            modules: [],
        },
        {
            icon: '<svg aria-hidden="true" data-prefix="far" data-icon="browser" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-browser fa-w-16 fa-2x" width="20px" height="20px"><path fill="currentColor" d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM48 92c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V92zm416 334c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V168h416v258zm0-310c0 6.6-5.4 12-12 12H172c-6.6 0-12-5.4-12-12V92c0-6.6 5.4-12 12-12h280c6.6 0 12 5.4 12 12v24z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/adstxt/{domId}/',
            name: 'Ads.txt',
            modules: [],
        },
        {
            icon: '<svg aria-hidden="true" data-prefix="far" data-icon="browser" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-browser fa-w-16 fa-2x" width="20px" height="20px"><path fill="currentColor" d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM48 92c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V92zm416 334c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V168h416v258zm0-310c0 6.6-5.4 12-12 12H172c-6.6 0-12-5.4-12-12V92c0-6.6 5.4-12 12-12h280c6.6 0 12 5.4 12 12v24z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/KeywordBlock/{domId}/',
            name: 'Keyword Block',
            modules: [],
        },

        {
            icon: '<svg aria-hidden="true" data-prefix="far" data-icon="browser" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-browser fa-w-16 fa-2x" width="20px" height="20px"><path fill="currentColor" d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM48 92c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V92zm416 334c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V168h416v258zm0-310c0 6.6-5.4 12-12 12H172c-6.6 0-12-5.4-12-12V92c0-6.6 5.4-12 12-12h280c6.6 0 12 5.4 12 12v24z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/{domId}/layout-setup/',
            name: 'Layouts',
            modules: [],
        },
        {
            icon: '<svg aria-hidden="true" data-prefix="far" data-icon="audio-description" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-audio-description fa-w-16 fa-2x" width="20px" height="20px"><path fill="currentColor" d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zm-212.541-63.861l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm-82.534-97.43l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zM331.2 160h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386 0-58.977-37.919-95.614-98.96-95.614zm-1.801 145.39h-14.523v-98.78h14.523c28.685 0 46.175 16.767 46.175 49.005 0 32.098-16.399 49.775-46.175 49.775z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/{domId}/ad-spot-setup/',
            name: 'Ad Spots',
            modules: [],
        },
        {
            icon: '<svg aria-hidden="true" data-prefix="far" data-icon="heading" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-heading fa-w-14 fa-2x" width="20px" height="20px"><path fill="currentColor" d="M300 80h36.703v149.983H111.297V80H148c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v24c0 6.627 5.373 12 12 12h35.841v352H12c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h136c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-36.703V282.016h225.406V432H300c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h136c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-35.841V80H436c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H300c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12z" class=""></path></svg>',
            isSvg: true,
            // path: '/admin/publisher/{uuid}/domain/{domId}/hb-tags/',
            name: 'Header Bidding',
            modules: [
                {
                    link: '/admin/publisher/{uuid}/domain/{domId}/hb-tags/',
                    name: 'HB Ad Units',
                },
                {
                    link: '/admin/publisher/{uuid}/domain/{domId}/hb-tag-param-sets/',
                    name: 'HB Param sets',
                },
                {
                    link: '/admin/publisher/{uuid}/domain/{domId}/hb-tags-amp/',
                    name: 'HB AMP',
                },
            ],
        },
        {
            icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 510 510" style="enable-background:new 0 0 510 510;" xml:space="preserve"><g><g id="do-not-disturb"><path d="M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M51,255c0-112.2,91.8-204,204-204    c45.9,0,89.25,15.3,124.95,43.35l-285.6,285.6C66.3,344.25,51,300.9,51,255z M255,459c-45.9,0-89.25-15.3-124.95-43.35    L415.65,130.05C443.7,165.75,459,209.1,459,255C459,367.2,367.2,459,255,459z" style="fill: rgb(255, 255, 255);"></path></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/{domId}/settings/block-urls/',
            name: 'URL Block',
            modules: [],
        },
        {
            icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-sliders-h fa-w-18"  width="20px" height="20px"><path fill="currentColor" d="M576 80v40c0 6.6-5.4 12-12 12H160v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-8H12c-6.6 0-12-5.4-12-12V80c0-6.6 5.4-12 12-12h84v-8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v8h404c6.6 0 12 5.4 12 12zm-12 148h-84v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h404v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0 160H288v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h212v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h276c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/{domId}/settings/edit/',
            name: 'Domain Settings',
            modules: [],
        },
    ],

    CreateTag: [
        {
            icon: '<svg xmlns="http://www.w3.org/2000/svg" height="64" viewBox="0 0 64 64" width="20"><g stroke-width=".067977" transform="matrix(2.4789208 0 0 2.4789208 -38.400527 -41.65855)"><circle cx="28.399668" cy="29.713959" fill="#0479c2" r="12.908843"/><path d="m29.364937 27.763019h3.12695s.65938 0 .31949.747747l-5.39058 8.972973h-.99926l.95168-5.866421-3.17453-.02039s-.56421-.224324-.13596-.951679l5.30221-8.769041h1.04005z" fill="#fff"/></g></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
            name: 'Manage Service',
            modules: [
                {
                    link: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
                    name: 'Tags',
                },
                {
                    link: '/admin/publisher/{uuid}/domain/{domId}/manage-story',
                    name: 'Stories',
                },
            ],
        },
    ],

    CreateStory: [
        {
            icon: '<svg xmlns="http://www.w3.org/2000/svg" height="64" viewBox="0 0 64 64" width="20"><g stroke-width=".067977" transform="matrix(2.4789208 0 0 2.4789208 -38.400527 -41.65855)"><circle cx="28.399668" cy="29.713959" fill="#0479c2" r="12.908843"/><path d="m29.364937 27.763019h3.12695s.65938 0 .31949.747747l-5.39058 8.972973h-.99926l.95168-5.866421-3.17453-.02039s-.56421-.224324-.13596-.951679l5.30221-8.769041h1.04005z" fill="#fff"/></g></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
            name: 'Manage Service',
            modules: [
                {
                    link: '/admin/publisher/{uuid}/domain/{domId}/manage-story',
                    name: 'Stories',
                },
                {
                    link: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
                    name: 'Tags',
                },
            ],
        },
    ],

    ManageService: [
        {
            icon: '<svg xmlns="http://www.w3.org/2000/svg" height="64" viewBox="0 0 64 64" width="20"><g stroke-width=".067977" transform="matrix(2.4789208 0 0 2.4789208 -38.400527 -41.65855)"><circle cx="28.399668" cy="29.713959" fill="#0479c2" r="12.908843"/><path d="m29.364937 27.763019h3.12695s.65938 0 .31949.747747l-5.39058 8.972973h-.99926l.95168-5.866421-3.17453-.02039s-.56421-.224324-.13596-.951679l5.30221-8.769041h1.04005z" fill="#fff"/></g></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
            name: 'Manage Service',
            modules: [
                {
                    link: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
                    name: 'Tags',
                },
                {
                    link: '/admin/publisher/{uuid}/domain/{domId}/manage-story',
                    name: 'Stories',
                },
            ],
        },
    ],
    /*-------------------------------------------------------------------*/
    DomainBucket: [
        {
            icon: '<svg aria-hidden="true" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16"  width="20px" height="20px"><path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/edit/{domId}/',
            name: 'Back to Bucket',
            modules: [],
        },
    ],

    BucketDetails: [
        {
            icon: '<svg aria-hidden="true" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16"  width="20px" height="20px"><path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/edit/{domId}',
            name: 'Back to Bucket',
            modules: [],
        },
        {
            icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-sliders-h fa-w-18"  width="20px" height="20px"><path fill="currentColor" d="M576 80v40c0 6.6-5.4 12-12 12H160v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-8H12c-6.6 0-12-5.4-12-12V80c0-6.6 5.4-12 12-12h84v-8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v8h404c6.6 0 12 5.4 12 12zm-12 148h-84v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h404v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0 160H288v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h212v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h276c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/{domId}/buckets/{bucketId}/settings',
            name: 'Settings',
            modules: [],
        },
    ],
    DfpSettings: [
        {
            icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-sliders-h fa-w-18"  width="20px" height="20px"><path fill="currentColor" d="M576 80v40c0 6.6-5.4 12-12 12H160v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-8H12c-6.6 0-12-5.4-12-12V80c0-6.6 5.4-12 12-12h84v-8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v8h404c6.6 0 12 5.4 12 12zm-12 148h-84v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h404v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0 160H288v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h212v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h276c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/dfp-settings/',
            name: 'DFP Settings',
            modules: [],
        },
    ],
    CreateHbTag: [
        {
            icon: '<svg aria-hidden="true" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16"  width="20px" height="20px"><path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/{domId}/buckets/{bucketId}/',
            name: 'Back to Bucket',
            modules: [],
        },
    ],
    ModifyHbTag: [
        {
            icon: '<svg aria-hidden="true" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16"  width="20px" height="20px"><path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/{domId}/buckets/{bucketId}/',
            name: 'Back to Bucket',
            modules: [],
        },
    ],
    HbTagParams: [
        {
            icon: '<svg aria-hidden="true" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16"  width="20px" height="20px"><path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/{domId}/buckets/{bucketId}/',
            name: 'Back to Bucket',
            modules: [],
        },
    ],
    ReportConfig: [
        {
            icon: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="cogs" class="svg-inline--fa fa-cogs fa-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"></path></svg>',
            isSvg: true,
            path: '/admin/reports/config',
            name: 'Reports Config',
            modules: [],
        },
    ],
    ReportParams: [
        {
            icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-sliders-h fa-w-18" width="20px" height="20px"><path fill="currentColor" d="M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"/></svg>',
            isSvg: true,
            path: '/admin/reports/',
            name: 'Back to Reports',
            modules: [],
        },
    ],
    StoryInfo: [
        {
            icon: '<svg xmlns="http://www.w3.org/2000/svg" height="64" viewBox="0 0 64 64" width="20"><g stroke-width=".067977" transform="matrix(2.4789208 0 0 2.4789208 -38.400527 -41.65855)"><circle cx="28.399668" cy="29.713959" fill="#0479c2" r="12.908843"/><path d="m29.364937 27.763019h3.12695s.65938 0 .31949.747747l-5.39058 8.972973h-.99926l.95168-5.866421-3.17453-.02039s-.56421-.224324-.13596-.951679l5.30221-8.769041h1.04005z" fill="#fff"/></g></svg>',
            isSvg: true,
            path: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
            name: 'Manage Service',
            modules: [
                {
                    link: '/admin/publisher/{uuid}/domain/{domId}/manage-story',
                    name: 'Stories',
                },
                {
                    link: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
                    name: 'Tags',
                },
            ],
        },
        {
            icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-sliders-h fa-w-18" width="20px" height="20px"><path fill="currentColor" d="M576 80v40c0 6.6-5.4 12-12 12H160v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-8H12c-6.6 0-12-5.4-12-12V80c0-6.6 5.4-12 12-12h84v-8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v8h404c6.6 0 12 5.4 12 12zm-12 148h-84v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h404v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0 160H288v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h212v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h276c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/stories/{storyId}/settings',
            name: 'Configuration',
            modules: [],
        },
    ],
    StoryParams: [
        {
            icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-sliders-h fa-w-18" width="20px" height="20px"><path fill="currentColor" d="M576 80v40c0 6.6-5.4 12-12 12H160v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-8H12c-6.6 0-12-5.4-12-12V80c0-6.6 5.4-12 12-12h84v-8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v8h404c6.6 0 12 5.4 12 12zm-12 148h-84v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h404v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0 160H288v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h212v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h276c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12z" class=""></path></svg>',
            isSvg: true,
            path: '/admin/stories/{storyId}/settings',
            name: 'Configuration',
            modules: [],
        },
    ],
};
import { UserManager, WebStorageStateStore } from 'oidc-client';
import authConfig from '../../authConfig';
export default {
    name: 'DashboardSidebar',
    data() {
        return {
            navigation: [],
            currentPath: this.$route.path,
            allAvailableRegexes: [],
            routePaths: []
        };
    },

    props: {
        domain_details: Object,
        is90d: Boolean,
    },
    mounted: function () {
        this.getSideBar(this.$route.name, this.$route.params, (navigation) => {
            // navigation = navigation.filter(nav => !["Prebid Floors", "Analytics"].includes(nav.name))
            this.navigation = navigation;
            console.log(navigation);
            window.setTimeout(function () {
                LetterAvatar.transform();
            });
        });

        $(document).ready(function ($) {
            $('.main-sidebar > div').slimScroll({
                width: '230px',
                position: 'left',
                size: '3px',
                height: '95vh',
            });
        });

        let _this = this;
        $(document).on('click', '#prod-association', () => {
            window.setTimeout(() => {
                _this.getSideBar(_this.$route.name, _this.$route.params, (navigation) => {
                    // navigation = navigation.filter(nav => !["Prebid Floors", "Analytics"].includes(nav.name))
                    _this.navigation = navigation;
                    console.log(navigation);
                    window.setTimeout(function () {
                        LetterAvatar.transform();
                    });
                });
            }, 1000);
        });
    },
    components: {
        Avatar,
    },
    computed: {
        _get_user() {
            // return this.$auth.user() || {};
            let token = window.localStorage && localStorage['default_auth_token'];
            if (token) {
                var base64Url = token.split('.')[1];
                var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                var jsonPayload = decodeURIComponent(
                    atob(base64)
                        .split('')
                        .map(function (c) {
                            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                        })
                        .join('')
                );

                return JSON.parse(window.atob(JSON.parse(jsonPayload)["urn:zitadel:iam:user:metadata"]["user_roles"]));
            } else return undefined;
        },
        hasAccess() {
            return [3, 8, 41, 155, 310, 290, 314, 630, 486, 454, 478, 637, 549, 554].includes(
                this._get_user && this._get_user.user_id
            );
        },
    },
    watch: {
        $route: function (newUrl, oldUrl) {
            console.log(newUrl);
            console.log(oldUrl);
            if (newUrl.path !== oldUrl.path) {
                this.getSideBar(newUrl.name, newUrl.params, (navigation, referPath) => {
                    this.currentPath = this.$route.path;
                    // navigation = navigation.filter(nav => !["Prebid Floors", "Analytics"].includes(nav.name))
                    this.navigation = navigation;
                    console.log(navigation);
                    window.setTimeout(function () {
                        LetterAvatar.transform();
                    });
                    // if(referPath && newUrl.path != referPath && !newUrl.query.click) this.$router.push(referPath);
                });
            }
        },
        deep: true,
    },
    created() {
        // ... existing code ...
        // Compute routePaths once
        let routePaths = [];
        if (typeof this.$router.getRoutes === 'function') {
            routePaths = this.$router.getRoutes().map(route => route.path);
        } else if (this.$router.options && this.$router.options.routes) {
            function getAllRoutePaths(routes) {
                let paths = [];
                routes.forEach(route => {
                    if (route.path) paths.push(route.path);
                    if (route.children) paths = paths.concat(getAllRoutePaths(route.children));
                });
                return paths;
            }
            routePaths = getAllRoutePaths(this.$router.options.routes);
        }
        this.routePaths = routePaths;
        // ... existing code ...
    },
    methods: {
        getSideBar: function (controllerName, params, callback) {
            console.log('Controller Name' + controllerName);
            console.log(this.$route.path);
            let setdata = function (params, path) {
                    if (path)
                        for (let key in params) path = path.replace(new RegExp('{' + key + '}', 'g'), params[key]);
                    return path;
                },
                fixUrl = function (navArray) {
                    for (let i = 0; i < navArray.length; i++) navArray[i].path = setdata(params, navArray[i].path);
                    return navArray;
                },
                cloneArray = function (array) {
                    return JSON.parse(JSON.stringify(array));
                },
                navbar = [];
            var routeSplit = this.$route.path.split('/');
            if (routeSplit[2] == 'undefined') {
                navbar = cloneArray(sidebarObj.Domain);
                callback(navbar);
            } else {
                switch (controllerName) {
                    case 'Domain':
                    case 'Stories':
                    case 'StoriesUndef':
                        navbar = cloneArray(sidebarObj.Domain);
                        callback(navbar);
                        break;

                    case 'Manage Services':
                        navbar = cloneArray(sidebarObj.ManageService);
                        navbar.forEach((nav) => {
                            if (nav.modules.length > 0) {
                                nav.modules.forEach((mod) => {
                                    mod.link = setdata(this.$route.params, mod.link);
                                });
                            }
                        });
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;

                    case 'Modify Manage Service Tag':
                    case 'Create Manage Service Tag':
                        navbar = cloneArray(sidebarObj.CreateTag);
                        navbar.forEach((nav) => {
                            if (nav.modules.length > 0) {
                                nav.modules.forEach((mod) => {
                                    mod.link = setdata(this.$route.params, mod.link);
                                });
                            }
                        });
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;

                    case 'Stories Create':
                    case 'Manage Stories':
                        navbar = cloneArray(sidebarObj.CreateStory);
                        navbar.forEach((nav) => {
                            if (nav.modules.length > 0) {
                                nav.modules.forEach((mod) => {
                                    mod.link = setdata(this.$route.params, mod.link);
                                });
                            }
                        });
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;

                    case 'EditDomain':
                    case 'DomainContext':
                    case 'AdsText':
                    case 'KeywordBlock':
                    case 'HbTagParams':
                    case 'HbTagDimensionParams':
                    case 'HbTagParamSet':
                    case 'Layout':
                    case 'ModifyHbTag':
                    case 'ModifyHbTagAmp':
                    case 'BlockURLS':
                    case 'HbTagParamsAMP':
                    case 'CreateHbTag':
                    case 'CreateHbTagAmp':
                    case 'FiSetupAdSpots':
                        navbar = cloneArray(sidebarObj.EditDomain);
                        navbar.forEach((nav) => {
                            if (nav.modules.length > 0) {
                                nav.modules.forEach((mod) => {
                                    mod.link = setdata(this.$route.params, mod.link);
                                });
                            }
                        });
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;

                    case 'AxtModule':
                    case 'Header-Bidding-Tags':
                    case 'AllDirectCampaign':
                    case 'StickyModule':
                    case 'FirstImpression':
                    case 'FiTagAssociation':
                    case 'BucketDetails':
                    case 'BucketSettings':
                    case 'StoryModule':
                        navbar = cloneArray(sidebarObj.BucketDetails);
                        let path = 'v1/publishers/{uuid}/domains/{domId}/buckets/{bucketId}/products/';
                        path = setdata(params, path);

                        axios.all([axios.get(BASE_URL + path)]).then(
                            axios.spread((response) => {
                                let redirPath = undefined;
                                for (let i = 0; i < response.data.length; i++) {
                                    if (response.data[i].product) {
                                        let modules = cloneArray(response.data[i].product.modules);
                                        for (var j = 0; j < modules.length; j++) {
                                            modules[j].link =
                                                '/admin/publisher/{uuid}/domain/{domId}/buckets/{bucketId}/' +
                                                modules[j].code.toLowerCase() +
                                                '/';
                                            modules[j].link = setdata(params, modules[j].link);

                                            if (j == 0) redirPath = modules[j].link;
                                        }

                                        navbar.push({
                                            icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="text-height" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-text-height fa-w-18 fa-2x" width="20px" height="20px"><path fill="currentColor" d="M16 32h288c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16h-35.496c-8.837 0-16-7.163-16-16V96h-54.761v320H232c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H88c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h34.257V96H67.496v48c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V48c0-8.837 7.163-16 16-16zm475.308 4.685l79.995 80.001C581.309 126.693 574.297 144 559.99 144H512v224h48c15.639 0 20.635 17.991 11.313 27.314l-79.995 80.001c-6.247 6.247-16.381 6.245-22.626 0l-79.995-80.001C378.691 385.307 385.703 368 400.01 368H448V144h-48c-15.639 0-20.635-17.991-11.313-27.314l79.995-80.001c6.247-6.248 16.381-6.245 22.626 0z" class=""></path></svg>',
                                            isSvg: true,
                                            path: undefined,
                                            name: response.data[i].product.name,
                                            modules: modules,
                                        });
                                    }
                                }

                                navbar = fixUrl(navbar);
                                if (!redirPath) redirPath = navbar[0].path;
                                callback(navbar, redirPath);
                            })
                        );
                        break;

                    case 'DomainBucket':
                        navbar = sidebarObj.DomainBucket;
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;
                    case 'ads.txt':
                        navbar = sidebarObj.ads.txt;
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;
                    case 'KeywordBlock':
                        navbar = sidebarObj.KeywordBlock;
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;
                    // case 'ReportsRevenue':
                    //     navbar = sidebarObj.ReportsRevenue;
                    //     navbar = fixUrl(navbar);
                    //     callback(navbar);
                    //  break;

                    case 'DfpSettings':
                        navbar = sidebarObj.DfpSettings.slice(0);
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;

                    case 'MediaList':
                        navbar = sidebarObj.MediaList.slice(0);
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;

                    case 'CreateHbTag':
                        navbar = sidebarObj.CreateHbTag.slice(0);
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;

                    case 'ModifyHbTag':
                        navbar = sidebarObj.ModifyHbTag.slice(0);
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;

                    case 'StoriesInfo':
                        navbar = cloneArray(sidebarObj.StoryInfo);
                        navbar.forEach((nav) => {
                            if (nav.modules.length > 0) {
                                nav.modules.forEach((mod) => {
                                    mod.link = setdata(this.$route.params, mod.link);
                                });
                                console.log('Route');
                                console.log(this.$route.params);
                            }
                        });
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;

                    case 'CreatePage':
                    case 'StoryConfig':
                        path = '/admin/stories/{storyId}/config';
                        path = setdata(params, path);
                        navbar = sidebarObj.StoryParams.slice(0);
                        navbar[1].path = `/admin/stories/${this.$route.params.storyId}/settings`; //temp solution
                        navbar = fixUrl(navbar);
                        callback(navbar);

                        break;

                    case 'reportApproval':
                    case 'BidderDfpReport':
                    case 'ReportsConfig':
                        path = '/admin/reports/';
                        path = setdata(params, path);
                        navbar = sidebarObj.ReportParams.slice(0);
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;

                    case 'Reports':
                        navbar = cloneArray(sidebarObj.ReportConfig.slice(0));
                        navbar = fixUrl(navbar);
                        callback(navbar);
                        break;

                    default:
                        callback([]);
                        break;
                }
            }
        },
        logout() {
            // Clear local storage
            localStorage.removeItem('default_auth_token');
            localStorage.removeItem('user');
            const userManager = new UserManager({
                userStore: new WebStorageStateStore({ store: window.localStorage }),
                ...authConfig,
            });
            userManager
                .signoutRedirect()
                .then(() => {
                    this.$notify({
                        title: 'Success',
                        message: 'You have successfully logged out.',
                        type: 'success',
                    });
                    console.log('Logout successful');
                    router.push({ name: 'Login' });
                })
                .catch((error) => {
                    console.error('Error in signoutRedirect:', error);
                });
        },
        isNavigationAllowed(module) {
            if (!module.link) return false;
            return this.routePaths.some(routePath => {
                if (routePath.includes(':')) {
                    // Build regex from routePath pattern
                    const pattern = '^' + routePath.replace(/:[^/]+/g, '[^/]+') + '/?$';
                    const regex = new RegExp(pattern);
                    return regex.test(module.link);
                }
                // Otherwise, check for equality (with or without trailing slash)
                return routePath.replace(/\/+$/, '') === module.link.replace(/\/+$/, '');
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// Sidebar.vue?0afe91fb